import React, { useState } from "react";
import VendorFinder from "./Main";
  
const Demo = () => {
  const [value, setValue] = useState(null)

  return (
    <>
      <VendorFinder
        default_value={1764}
        value={value}
        show_address={true}
        onChange={(val) => setValue(val)}
      />
      <br/>
      {value && <ul>
        <li>ID: {value.id}</li>
        <li>Name: {value.name}</li>
      </ul>}
    </>
  )
}

export default Demo;
